export default {
	ADMIN_ONBOARDING_ADD_USER: 'admin_onboarding_add_user',
	BINDERS_CREATE: 'binders_create',
	BINDERS_LESSON_CODES: 'binders_lesson_codes',
	BINDERS_LESSONS_PICKER: 'binders_lessons_picker',
	BINDERS_NOTES: 'binders_notes',
	DRAW_IT_BACKGROUND_IMAGE_PICKER: 'draw_it_background_image_picker',
	DRAW_IT_CT_TIMER: 'draw_it_ct_timer',
	DRAW_IT_REFERENCE_MEDIA_PICKER: 'draw_it_reference_media_picker',
	GAME_IMAGE_ANSWER_PICKER: 'game_image_answer_picker',
	GAME_QUESTION_MEDIA_PICKER: 'game_question_media_picker',
	GAME_TIMER_QUESTION: 'game_timer_question',
	GOOGLE_SLIDES_UNAUTHORIZED_CREATE: 'google_slides_unauthorized_create',
	INTERACTIVE_VIDEO_ACTIVITY_PICKER: 'interactive_video_activity_picker',
	INTERACTIVE_VIDEO_SETTINGS: 'interactive_video_settings',
	INTERACTIVE_VIDEO_TRIM_CHANGE_NOT_SAVED: 'interactive_video_trim_change_not_saved',
	LESSON_CODES_LAUNCH_LIVE_SESSION: 'lesson_codes_launch_live_session',
	LESSON_CODES_LAUNCH_STUDENT_PACED: 'lesson_codes_launch_student_paced',
	LESSON_PREVIEW: 'lesson_preview',
	MATCHING_PAIRS_ADD_IMAGE_PICKER: 'matching_pairs_add_image_picker',
	MATCHING_PAIRS_CT_PAIR: 'matching_pairs_ct_pair',
	MATCHING_PAIRS_CT_PREVIEW: 'matching_pairs_ct_preview',
	MATCHING_PAIRS_CT_TIMER: 'matching_pairs_ct_timer',
	MEDIA_PREVIEW: 'media_preview',
	MY_ACCOUNT_NEARPOD_PICKER: 'my_account_nearpod_picker',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY: 'my_library_add_lesson_to_private_library',
	MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER: 'my_library_add_multiple_lessons_to_folder',
	MY_LIBRARY_ADD_TO_FOLDER: 'my_library_add_to_folder',
	MY_LIBRARY_LAUNCH_HOMEWORK: 'my_library_launch_homework',
	MY_LIBRARY_LAUNCH_SESSION_TEAMS: 'my_library_launch_session_teams',
	MY_LIBRARY_NAME_FOLDER: 'my_library_name_folder',
	MY_LIBRARY_TEACH_MODAL: 'my_library_teach_modal',
	OEQ_CT_TIMER: 'oeq_ct_timer',
	OEQ_NEARPOD_PICKER: 'oeq_nearpod_picker',
	QUICK_LAUNCH_COLLABORATE_CREATE: 'quick_launch_collaborate_create',
	QUICK_LAUNCH_TIMER_CREATE: 'quick_launch_timer_create',
	QUIZ_NEARPOD_PICKER: 'quiz_nearpod_picker',
	QUIZ_TIMER: 'quiz_timer',
	PLAYGROUND_NEARPOD_PICKER: 'playground_nearpod_picker',
	PLAYGROUND_SAMPLE: 'playground_sample',
	POLL_CT_TIMER: 'poll_ct_timer',
	POLL_NEARPOD_PICKER: 'poll_nearpod_picker',
	POLL_SETTINGS: 'poll_settings',
	PRIVATE_LIBRARY_ADD_TO_FOLDER: 'private_library_add_to_folder',
	PRIVATE_LIBRARY_LESSONS_PICKER: 'private_library_lessons_picker',
	PRIVATE_LIBRARY_NAME_FOLDER: 'private_library_name_folder',
	PRIVATE_LIBRARY_SETTINGS: 'private_library_settings',
	SAVE_CHANGES: 'save_changes',
	SHARE: 'share',
	SHOW_PASSWORD_FORM: 'show_password_form',
	STOREFRONT_GRADES_SUBJECTS_PICKER: 'storefront_grades_subjects_picker',
	STOREFRONT_LESSONS_PICKER: 'storefront_lessons_picker',
	SWITCH_LIBRARY: 'switch_library',
	REFER_CONTACT: 'refer_contact',
	UNLOCK_LESSONS: 'unlock_lessons',
	INTERACTIVE_VIDEO_EDITOR_TRIM_TOOLTIP: 'interactive_video_editor_trim_tooltip',
}
